import { render } from "./PersonInfoStepComponent.vue?vue&type=template&id=3f32080f&ts=true"
import script from "./PersonInfoStepComponent?vue&type=script&lang=ts"
export * from "./PersonInfoStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__